import React from "react";

const HiddenField = ({ name, inputValue, inputId }) => {
  return (
    <>
      <input type="hidden" name={name} id={inputId} value={inputValue} />
    </>
  );
};
export default HiddenField;
